import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/medical-weight-loss/other-medications")({
  beforeLoad: () => {
    throw redirect({
      to: "/medical-weight-loss/oral-medications",
      statusCode: 301,
    });
  },
  component: () => null,
});
